import { render, staticRenderFns } from "./StepperPasoDos.vue?vue&type=template&id=753a52b0"
import script from "./StepperPasoDos.vue?vue&type=script&setup=true&lang=js"
export * from "./StepperPasoDos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports